import { render, staticRenderFns } from "./MostrarArchivoPdfOImagen.vue?vue&type=template&id=7ec423cc&scoped=true"
import script from "./MostrarArchivoPdfOImagen.vue?vue&type=script&lang=js"
export * from "./MostrarArchivoPdfOImagen.vue?vue&type=script&lang=js"
import style0 from "./MostrarArchivoPdfOImagen.vue?vue&type=style&index=0&id=7ec423cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec423cc",
  null
  
)

export default component.exports